import { type AddressDto } from './Address';
import { type AttachmentDto } from './AttachmentDto';
import { type EnumType } from './EnumType';

export type SetupRequestDto = {
  social_name: string;
  fantasy_name?: string;
  person_type?: EnumType;
  cnpj: string;
  cpf?: string;
  state_registration?: string;
  municipal_registration?: string;
  address?: AddressDto;
  logo?: AttachmentDto;
  website?: string;
  email?: string;
  administrator_email?: string;
  administrator_password?: string;
  registration_date?: string;
  modification_date?: string;
  number_of_employees?: number | null;
  telephone?: string;
  whatsapp?: string;
  instagram?: string;
  facebook?: string;
  tax_regime?: EnumType;
  income_tax_regime?: EnumType;
};

export const initialSetupRequestEmpty: SetupRequestDto = {
  social_name: '',
  fantasy_name: '',
  person_type: { value: 'LEGAL', description: 'Pessoa jurídica' },
  cnpj: '',
  cpf: '',
  state_registration: '',
  address: {
    zip_code: '',
    street: '',
    number: '',
    neighborhood: '',
    complement: '',
    city: '',
  },
  municipal_registration: '',
  website: '',
  email: '',
  administrator_email: '',
  administrator_password: '',
  registration_date: '',
  modification_date: '',
  number_of_employees: null,
  telephone: '',
  whatsapp: '',
  instagram: '',
  facebook: '',
};
